import { render, staticRenderFns } from "./Paintings.vue?vue&type=template&id=44fa62e2&"
import script from "./Paintings.vue?vue&type=script&lang=js&"
export * from "./Paintings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports